import React from "react";

const ChillerVanPricing = ({ title, description, tiers, tiersNote, routeTables, zoneTables, note }) => {
  return (
    <section className="cv-pricing-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        {/* Rental tier cards */}
        <div className="row g-4 mb-5">
          {tiers.map((tier, i) => (
            <div
              key={i}
              className="col-md-4"
              data-aos="zoom-in"
              data-aos-delay={`${i * 150}`}
              data-aos-once="true"
            >
              <div className="cv-pricing-tier-card">
                <h3>{tier.label}</h3>
                <p>{tier.note}</p>
                <table className="cv-pricing-mini-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Without Driver</th>
                      <th>With Driver</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>{tier.label.replace(" Rental", "")}</th>
                      <td>{tier.withoutDriver}</td>
                      <td>{tier.withDriver}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        {/* Note after tiers */}
        {tiersNote && (
          <p className="cv-pricing-tiers-note">{tiersNote}</p>
        )}

        {/* Route pricing tables */}
        <div className="row g-4 mb-4">
          {routeTables.map((rt, i) => (
            <div
              key={i}
              className={routeTables.length > 1 ? "col-md-6" : "col-12"}
              data-aos="fade-up"
              data-aos-delay={`${i * 150}`}
              data-aos-once="true"
            >
              <h3 className="cv-pricing-table-title">{rt.title}</h3>
              <div className="table-responsive">
                <table className="cv-pricing-route-table">
                  <thead>
                    <tr>
                      <th>From</th>
                      <th>To</th>
                      <th>Without Driver</th>
                      <th>With Driver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rt.rows.map((row, ri) => (
                      <tr key={ri}>
                        <td>{row.from}</td>
                        <td>{row.to}</td>
                        <td>{row.withoutDriver}</td>
                        <td>{row.withDriver}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        {/* Internal zone tables */}
        <div className="row g-4 mb-4">
          {zoneTables.map((zt, i) => (
            <div
              key={i}
              className={zoneTables.length > 1 ? "col-md-6" : "col-12"}
              data-aos="fade-up"
              data-aos-delay={`${i * 150}`}
              data-aos-once="true"
            >
              <h3 className="cv-pricing-table-title">{zt.title}</h3>
              <div className="table-responsive">
                <table className="cv-pricing-route-table">
                  <thead>
                    <tr>
                      <th>From</th>
                      <th>To</th>
                      <th>Without Driver</th>
                      <th>With Driver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {zt.rows.map((row, ri) => (
                      <tr key={ri}>
                        <td>{row.from}</td>
                        <td>{row.to}</td>
                        <td>{row.withoutDriver}</td>
                        <td>{row.withDriver}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        {note && <p className="cv-pricing-note">{note}</p>}
      </div>
    </section>
  );
};

export default ChillerVanPricing;
